import { useState } from 'react';
import { Card, Stack, Group, Badge, Text, Button, Code } from '../../../../components/ui';
import { Box } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import { getStatusColor, getStatusIcon } from '../utils/systemHelpers.tsx';
import type { HealthCheckCardProps } from '../types';

export function HealthCheckCard({ name, entry }: HealthCheckCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card withBorder>
      <Stack gap="sm">
        <Group justify="space-between">
          <Group gap="sm">
            {getStatusIcon(entry.status)}
            <Text size="sm" fw={600}>
              {name}
            </Text>
          </Group>
          <Badge color={getStatusColor(entry.status)} variant="light">
            {entry.status}
          </Badge>
        </Group>

        {entry.description && (
          <Text size="xs" c="dimmed">
            {entry.description}
          </Text>
        )}

        <Group gap="md">
          <Group gap={4}>
            <IconClock size={14} />
            <Text size="xs" c="dimmed">
              {entry.duration}
            </Text>
          </Group>
          {entry.tags && entry.tags.length > 0 && (
            <Group gap={4}>
              {entry.tags.map((tag) => (
                <Badge key={tag} size="xs" variant="outline">
                  {tag}
                </Badge>
              ))}
            </Group>
          )}
        </Group>

        {entry.data && Object.keys(entry.data).length > 0 && (
          <>
            <Button size="xs" variant="subtle" onClick={() => setExpanded(!expanded)}>
              {expanded ? 'Hide Details' : 'Show Details'}
            </Button>
            {expanded && (
              <Box>
                <Code block>{JSON.stringify(entry.data, null, 2)}</Code>
              </Box>
            )}
          </>
        )}
      </Stack>
    </Card>
  );
}
